<template>
    <div style="display:flex; flex-direction:column; justify-content:center; align-items:center;">
      <Header></Header>
      <HeaderSec Title="裸金属一体机：Blueiaas-LX5-ML021" Desc="" :BreadcrumbList="BreadcrumbList"></HeaderSec>
      <Row style="padding:20px;" gutter="24" class="list">
          <Col :xs="22" :sm="22" :md="22" :lg="22" :xl="18" :xxl="18">
            <Card style="width:100%" :bordered="false" :dis-hover="true" :shadow="true">
              <template #title>
                <Title :level="5">
                  <Icon type="ios-film-outline"></Icon>
                  产品简介： LX5-ML021
                </Title>
              </template>
              <div style="display: flex; flex-direction:row; justify-content:space-between;">
                <Typography>
                  <Paragraph>
                    <Title :level="6">搭配均衡，适合做裸金属服务器，承载SQLServer等数据库和需要高主频处理能力的应用的运行</Title>
                  </Paragraph>
                  <Paragraph>
                    <ul>
                        <li>更加偏向于高主频的应用，CPU的频率相对较高</li>
                        <li>全闪设计，高度可靠数据保护的同时，仍然兼顾了现代应用越来越高的IO要求（三盘3.84TB-raid5版本，￥{{ Price['LX5-ML021'][0] }}）</li>
                        <li>全闪阵列+PCI-E卡闪存卡，极致性能释放，搭配应用层备份，可以满足性能和安全的双重极致要求（三盘3.84TB-raid5+6.2TB卡式闪存版本，￥{{ Price['LX5-ML021'][1] }}）</li>
                        <li>支持IPMI，可以进行裸金属管理，轻松和虚拟化平台组合，形成混合计算能力。</li>
                    </ul>
                  </Paragraph>
                  <Paragraph>
                    <Title :level="6">典型应用场景</Title>
                    <Text>处在初步信息化阶段的中小企业，或者用于在大型IT结构中运行非核心部分的业务。一体机的形式，x86的处理器架构，适应当前最广泛的企业应用架构，全闪阵列设计，并可选支持PCI-E的高速闪存卡，主打高IO，并具有良好的数据保护能力。</Text>
                  </Paragraph>
                </Typography>
                <Image src="https://www.bluehci.com/images001/server001.png" fit="contain" width="270px" height="161px" alt="contain" />
              </div>
            </Card>
            <Card style="width:100%" :bordered="false" :dis-hover="true" :shadow="true">
              <template #title>
                <Title :level="5">
                  <Icon type="ios-list" />
                  技术参数
                </Title>
              </template>
              <Table :columns="columns" :data="data"></Table>
            </Card>
            <Card style="width:100%" :bordered="false" :dis-hover="true" :shadow="true">
              <template #title>
                <Title :level="5">
                  <Icon type="ios-medal-outline" />
                  产品优势
                </Title>
              </template>
              <Typography>
                <Paragraph>
                  <Text>高频CPU+高速全闪或PCI-E闪存卡，为应用提供更好的性能支持，尤其对数据库类型的应用更加友好，支持友好界面的IPMI，可以方便的和虚拟化平台构建混合计算能力。</Text>
                </Paragraph>
              </Typography>
            </Card>
          </Col>
          <Col :xs="0" :sm="0" :md="0" :lg="0" :xl="6" :xxl="6">
            <BlueiaasSideList></BlueiaasSideList>
          </Col>
      </Row>
    </div>
</template>

<script>
import BlueiaasSideList from '@/components/Blueiaas-sideList.vue'
import Header from '@/components/Header.vue'
import HeaderSec from '@/components/HeaderSec.vue'
import RPrice from '@/http/Price.js'
export default {
  name: 'Blueiaas-LX5-ML021',
  components: {
    BlueiaasSideList,
    Header,
    HeaderSec
  },
  setup() {
  },
  data(){
    return {
        BreadcrumbList: [
            {
                title: '首页',
                to: '/'
            },
            {
                title: '云与基础设施',
                to: '/Blueiaas'
            },
            {
                title: 'Blueiaas-LX5-ML021'
            }
        ],
        Price: {
          /** 256GB, 512GB */
          "LX5-HL101": [ 0, 0],
          "LX5-HS101": [ 0, 0],
          "LX5-HP101": [ 0, 0],
          "LX5-HL302": [ 0, 0],
          "LX5-HS302": [ 0, 0],
          "LX5-HP302": [ 0, 0],
          "LX5-HL303": [ 0, 0],
          "LX5-HS303": [ 0, 0],
          "LX5-HP303": [ 0, 0],
          "LX5-ML021": [0, 0],
          "LX5-ML022": [0, 0],
          "LX5-ML023": [0, 0],
          "LX5-MP022": [0, 0],
        },
        columns: [
            {
                title: '技术项',
                key: 'key',
            },
            {
                title: '参数',
                key: 'value'
            },
        ],
        data: [
            {
              key:"型号",
              value:"LX5-ML021",
            },
            {
              key:"机型",
              value:"2U标准机架设备，8盘位热插拔（C62128F）",
            },
            {
              key:"处理器",
              value:"Intel® 至强 金牌6134 3.2GHz 8核16线程 * 2 ",
            },
            {
              key:"内存",
              value:"128GB",
            },
            {
              key:"存储",
              value:"固态硬盘 3.84TB SSD * 3（raid5） + 可选PCI-E 6.2TB闪存卡",
            },
            {
              key:"RAID控制器",
              value:"LSI 9361-8I,1G缓存，支持raid 0.1.5.10.50.60",
            },
            {
              key:"网络接口",
              value:"1Gbps网线接口 * 2； IPMI网线接口 * 1",
            },
            {
              key:"电源",
              value:"800W 1+1 冗余电源",
            },
            {
              key:"导轨",
              value:"静态导轨, 适用于2/4柱式机架",
            },
            {
              key:"外型尺寸",
              value:"43x437x724mm(WHD)",
            },
            {
              key:"工作环境",
              value:"10~35C(50~95F)，10%~90%，存储环境：-10~60C，10%~90%（非冷凝）",
            },
            {
              key:"系统支持",
              value:"Windows，Redhat linux， centos， ubuntu",
            },
        ],
    }
  },
  methods: {
    handleClick() {
      this.$Message.info('Welcome to View UI Plus Demo!')
    }
  },
  mounted () {
    this.Price = RPrice.getPrice();
  }
}
</script>

<style lang="less" scoped>
.list{
  width: 90%;
}
@media (min-width: 1000px) {
  .list{
    width: 1600px;
  }
}
</style>
